import React from "react";
import { Button, ButtonGroup } from "reactstrap";

interface LanguageSwitchProps {
    value: "tr" | "en";
    onChange: (lang: "tr" | "en") => void;
    className?: string;
}

const LanguageSwitch: React.FC<LanguageSwitchProps> = ({ value, onChange, className }) => {
    return (
        <ButtonGroup className={className}>
            <Button
                color={value === "tr" ? "primary" : "secondary"}
                onClick={() => onChange("tr")}
                active={value === "tr"}
            >
                🇹🇷 Türkçe
            </Button>
            <Button
                color={value === "en" ? "primary" : "secondary"}
                onClick={() => onChange("en")}
                active={value === "en"}
            >
                🇺🇸 English
            </Button>
        </ButtonGroup>
    );
};

export default LanguageSwitch;
